import { render, staticRenderFns } from "./QuiltyResourceListView.vue?vue&type=template&id=d884050c&scoped=true&"
import script from "./QuiltyResourceListView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceListView.vue?vue&type=script&lang=ts&"
import style0 from "./QuiltyResourceListView.vue?vue&type=style&index=0&id=d884050c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d884050c",
  null
  
)

export default component.exports